<div id="orderTypeFilterId" class="mt2 card card__block container bg-gray-97 border-navy-87">
  <div class="container">
    <div class="row no-edge-gutters">
      <div class="col-4">
        <div class="form-group container">
          <div class="row no-edge-gutters">
            <div class="col-12">
              <label for="TouchSelect">Order Source</label>
            </div>
          </div>
          <div class="row no-edge-gutters">
            <div class="col-12">
              <div class="touch-radio--horizontal-wrapper">
                <div class="touch-radio flex-1 ">
                  <input id="filterNucleusOrder" type="radio" [checked]="isNucleusOrderChecked" (change)="onFilterByNucleusOrderChanged()">
                  <label for="filterNucleusOrder" id="lblFilterNucleusOrder" class="text-small">Station</label>
                </div>
                <div class="touch-radio flex-1 ">
                  <input id="filterExternalOrder" type="radio" [checked]="isExternalOrderChecked" (change)="onFilterByExternalOrderChanged()">
                  <label for="filterExternalOrder" id="lblFilterExternalOrder" class="text-small">External</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
